import { render, staticRenderFns } from "./ComptaChips.vue?vue&type=template&id=d83e76a4"
import script from "./ComptaChips.vue?vue&type=script&lang=js"
export * from "./ComptaChips.vue?vue&type=script&lang=js"
import style0 from "./ComptaChips.vue?vue&type=style&index=0&id=d83e76a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports